import { render } from "./TaxReport.vue?vue&type=template&id=9c4923e2&scoped=true"
import script from "./TaxReport.vue?vue&type=script&lang=js"
export * from "./TaxReport.vue?vue&type=script&lang=js"

import "./TaxReport.vue?vue&type=style&index=0&id=9c4923e2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4923e2"]])

export default __exports__